import axios from "axios";
import Swal from 'sweetalert2'

import jquery from 'jquery';
window.jQuery = window.$ = jquery;

$(function () {

    $(document).on("click", ".addCart", function () {

        var entityid = $(this).data("id");
        var quantityField = $(this).data("input");
        var excludeTax = $(this).data("excludetax");

        //console.log(`excludeTax: ${excludeTax}`)

        var qty = 1.0;
        if (quantityField) {
            var textquantity = $('#' + quantityField).val();
            if (!isNaN(parseFloat(textquantity))) {
                qty = parseFloat(textquantity);
            }
        }

        var FormatoConfezione = 1.0;
        var formatoSelected = $("[id*=rbTipologiaConfezione]:checked").val();
        if (formatoSelected) {
            if (!isNaN(parseFloat(formatoSelected))) {
                FormatoConfezione = parseFloat(formatoSelected);
            }
        }
       
        axios
        .post(`${window.baseurl}/api/ShopCart/Add`, {
            entityId: entityid,
            quantity: qty * FormatoConfezione,
            note: "",
            culture: window.culture,
            ExcludeTax: excludeTax
        })
        .then(function (response) {
            Swal.fire({
                background: '#2f52a0',
                text: $("[id*=MessageBoxText]").val(),
                confirmButtonColor: '#d1112f',
                color: '#ffffff',
                customClass: 'swal-wide',
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
                reverseButtons: true,
                focusCancel: true,
                cancelButtonText: $("[id*=MessageBoxContinue]").val(),
                confirmButtonText: $("[id*=MessageBoxToCheckOut]").val()
            }).then((result) => {
                if (result.value) {
                    window.location.href = $("[id*=CheckOutUrl]").val()
                }
            }); 

            //trigger add to cart event datalayer
            //console.log(response.data.data);
            $("[id*=DataLayerAddToCartID]").val(response.data.data.cartDetailId);
            $("[id*=DataLayerAddToCartQty]").val(qty * FormatoConfezione);
            $("[id*=triggerDataLayerAddToCart]").trigger("click");

            window.refreshCartCount();
        })
        .catch(function (error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.message
            })

            //console.log(error);
        });

       

        return false;
    });

    $(".btnresa").on("click", function () {

        $("[id*=divError]").addClass("d-none");

        var txtValoreSelezionato = $("[id*=valoreSelezionato]").val().replace(',', '.');
        var valoreSelezionato = parseFloat(txtValoreSelezionato);
        if (isNaN(valoreSelezionato))
        {
            //console.log("valore selezionato non valido");
            $("[id*=divError]").removeClass("d-none");
            $("[id*=divTesto]").addClass("d-none");
            return;
        }
        
        var txtValoreInserito = $("[id*=valoreInserito]").val().replace(',', '.');
        var valoreInserito = parseFloat(txtValoreInserito);
        if (isNaN(valoreInserito) || valoreInserito <= 0)
        {
            //console.log("valore inserito non valido");
            $("[id*=divError]").removeClass("d-none");
            $("[id*=divTesto]").addClass("d-none");
            return;
        }

        //console.log(`valore selezionato: ${valoreSelezionato}, valore inserito ${valoreInserito}`);
        var risultato = (valoreInserito / valoreSelezionato);
        //console.log(`risultato: ${risultato}`);

        if (risultato && risultato > 0)
        {
            var productName = $("[id*=ProductName]").val();
            var type = $("[id*=valoreSelezionato] option:selected").text();

            var Testo = $("[id*=texttoreplace]").val().replace("[PRODUCTNAME]", productName).replace("[TYPE]", type);
            $("[id*=textreplaced]").html(Testo);

            var Valore = $("[id*=valuetoreplace]").val().replace("[NUMBER]", risultato.toFixed(2));
            $("[id*=valuereplaced]").html(Valore);

            $("[id*=divTesto]").removeClass("d-none");
            $("[id*=btnresacalcolata]").trigger("click")
        }
    });

    $('input[name="rbTipologiaConfezione"]').on('change', function (e) {

        var value = parseFloat(this.value);
        if (isNaN(value)) { value = 1; }

        //console.log(value);
        if (value > 1)
        {
            $("[id*=singlePrice]").addClass("d-none");
            $("[id*=confPrice]").removeClass("d-none");
        }
        else
        {
            $("[id*=confPrice]").addClass("d-none");
            $("[id*=singlePrice]").removeClass("d-none");
        }
      
    });
});